import EventGenerate from '@/screens/EventGenerate';

export default function PrivateEventGenerateIndexRoute() {
  return <EventGenerate />;
}
